import * as React from 'react';
import { LabSimAppUrl } from '../Environment';
import './DemoAccess.scss';

interface ISalesContact {
    firstName: string;
    lastName: string;
    email: string;
    meetingLink: string;
}

interface ICredentialsResponse {
    login?: string;
    password?: string;
    salesContact?: ISalesContact;
    error?: string;
}

interface IDemoAccessProps {

}

interface IDemoAccessState {
    credentials: ICredentialsResponse | null;
}

export default class DemoAccess extends React.PureComponent<IDemoAccessProps, IDemoAccessState> {
    constructor(props: IDemoAccessProps) {
        super(props);
        this.state = {credentials: null};
    }

    async componentDidMount() {
        const response = await fetch(`/api/demolink/credentials${window.location.search}`);
        if (response.status == 200) {
            const data = await response.json() as ICredentialsResponse;
            this.setState({ credentials: data });
        }
        else this.setState({ credentials: { error: "An error occurred in communicating with our servers. Please verify your Internet connection and refresh this page in your browser." } as ICredentialsResponse });
    }

    render() {
        return <div className="DemoAccess">
            <header>
                <img src="../Content/labsim_logo_small_250w.png" alt="LabSim" />
            </header>

            {this.state.credentials == null && <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                <span className="sr-only">Loading...</span>
            </div>}

            {this.state.credentials != null && <div className="Main">
                <div>
                    {this.state.credentials.error == null && <>
                        <p>A LabSim Demo account has been created for you with 7 Days of product access. You may use the demo account by signing on to LabSim with the following credentials:</p>
                        <div className="Credentials">
                            <div><span>Username</span><span>{this.state.credentials.login}</span><a onClick={() => navigator.clipboard.writeText(this.state?.credentials?.login as string)}>Copy</a></div>
                            <div><span>Password</span><span>{this.state.credentials.password}</span><a onClick={() => navigator.clipboard.writeText(this.state?.credentials?.password as string)}>Copy</a></div>
                        </div>
                        <p>Please make note of your credentials and then proceed to the LabSim login page <a href={LabSimAppUrl} target="_blank">by clicking this link</a> or by clicking the login button at www.TestOut.com.</p>
                    </>}
                    {this.state.credentials.error != null && <p>{this.state.credentials.error}</p>}
                </div>
            </div>}

            {this.state.credentials != null && (this.state.credentials.salesContact == null || this.state.credentials.salesContact.email == null) && <footer>
                <p>You may contact TestOut Sales at 800-877-4889 or email <a href="mailto:sales@testout.com">sales@testout.com</a></p>
            </footer>}
            {this.state.credentials != null && this.state.credentials.salesContact != null && this.state.credentials.salesContact.email != null && <footer>
                {this.state.credentials.salesContact.email != null && <p>
                    <span>Your sales contact is {this.state.credentials?.salesContact?.firstName} {this.state.credentials?.salesContact?.lastName}.</span>
                    <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Email: <a href={`mailto:${this.state.credentials?.salesContact?.email}`}>{this.state.credentials?.salesContact?.email}</a></span>
                    {this.state.credentials?.salesContact?.meetingLink != null && <span><br /><a href={this.state.credentials?.salesContact?.meetingLink} target="_blank">Click here</a> to schedule a meeting with {this.state.credentials?.salesContact?.firstName}.</span>}
                </p>}
            </footer>}
        </div>;
    }
}